import type { BreadcrumbItem } from '@/components/Breadcrumb';
import Breadcrumb from '@/components/Breadcrumb';
import { PRIMARY_MARKETS } from '@/constants/markets';
import { ROUTE_NARRATIVE_COMMUNITY } from '@/constants/routes';
import { useMemo } from 'react';
import { findPrimaryIndustryBySlug } from '../../utils/findPrimaryIndustryBySlug';

type Props = {
  companyNameSlug: string | undefined | null;
  companyName: string | undefined | null;
  exchangeTicker: string | undefined | null;
  market: string | undefined | null;
  primaryIndustrySlug: string | undefined | null;
};

export const NarrativeCommunityBreadcrumbs = ({
  companyNameSlug,
  companyName,
  exchangeTicker,
  market,
  primaryIndustrySlug,
}: Props) => {
  const breadcrumbs = useMemo(() => {
    const readableCountry = market
      ? PRIMARY_MARKETS[market]?.label || 'Global'
      : 'Global';

    const { primaryIndustryLabel } =
      findPrimaryIndustryBySlug(primaryIndustrySlug);

    if (!market) return [];

    return [
      {
        name: 'Community',
        canonicalUrl: '/community/narratives',
        dispatch: {
          type: ROUTE_NARRATIVE_COMMUNITY,
          payload: {},
        },
      },
      Boolean(market) && {
        name: readableCountry,
        canonicalUrl: `/community/narratives/${market}`,
        dispatch: {
          type: ROUTE_NARRATIVE_COMMUNITY,
          payload: {
            country: market,
          },
        },
      },
      Boolean(market && primaryIndustrySlug) && {
        name: primaryIndustryLabel,
        canonicalUrl: `/community/narratives/${market}/${primaryIndustrySlug}`,
        dispatch: {
          type: ROUTE_NARRATIVE_COMMUNITY,
          payload: {
            country: market,
            industry: primaryIndustrySlug,
          },
        },
      },
      Boolean(
        market &&
          primaryIndustrySlug &&
          exchangeTicker &&
          companyName &&
          companyNameSlug
      ) && {
        name: companyName,
        canonicalUrl: `/community/narratives/${market}/${primaryIndustrySlug}/${exchangeTicker}/${companyNameSlug}`,
        dispatch: {
          type: ROUTE_NARRATIVE_COMMUNITY,
          payload: {
            country: market,
            industry: primaryIndustrySlug,
            companyname: companyNameSlug,
            exchange_ticker: exchangeTicker,
          },
        },
      },
    ].filter(Boolean) as BreadcrumbItem[];
  }, [
    companyNameSlug,
    companyName,
    exchangeTicker,
    market,
    primaryIndustrySlug,
  ]);

  return (
    <div className="text-solid [&_*]:gap-x0_5 [&_*]:text-tiny [&_*]:no-underline [&_a:focus]:text-soft">
      <Breadcrumb list={breadcrumbs} />
    </div>
  );
};
